import { apiGetClient } from "../../api/apiDmsService";
import { toast } from 'react-toastify';

export const getAllPublishedFiles = async (data) => {
    try {
        const response = await apiGetClient.get(`documents/${data.typeId}/${data.subTypeId}/users`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const downloadFile = async (data) => {
    try {
        const response = await apiGetClient.get(`documents/download/${data.documentMetaDataId}`, {
                responseType: "blob",
            });
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const filterFiles = async (data, typeId, subTypeId) => {
    try {
        const response = await apiGetClient.get(`documents/filter/${typeId}/${subTypeId}?title=${encodeURIComponent(data?.name)}&language=${encodeURIComponent(data?.language)}`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const filterDoctypeFiles = async (data, typeId) => {
    try {
        const response = await apiGetClient.get(`documents/filter/${typeId}?title=${encodeURIComponent(data?.name)}&language=${encodeURIComponent(data?.language)}`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const getUserFilesOnDbClick = async (typeId) => {
    try {
        const response = await apiGetClient.get(`documents/documents/types/${typeId}`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};

export const getAllDocuments = async (data) => {
    try {
        const response = await apiGetClient.get(`documents/filter/all?title=${data?.name}&language=${data?.language}`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error,{position: "top-center",theme: "dark"});
        return null;
    }
};